import './footer.scss'
import React from 'react'
import ImageGenerator from '../image-generator/image-generator';
import logo from '../../../src/assets/images/bebin-logo.svg';
import bazaar from '../../../src/assets/images/bazaar-logo-and-logotype 1.svg';
import satra from '../../../src/assets/images/satra.webp';
import sapraa from '../../../src/assets/images/sapraa.webp';
import googlePlay from '../../../src/assets/images/en_badge_web_generic 1.svg';
import { Link } from 'react-router-dom';
import { useConfigApp } from '../../shared/services/general/app-context';
export default function Footer() {
	const configApp = useConfigApp();
	return (
		<footer>
			<div className="footer-container">
				<div className="right-side">
					<div className='download-ways'>
						<div className="d-flex align-items-center">
							<div className='w'>
								<ImageGenerator src={logo} />
							</div>
							<div className='title'>
								اپلیکیشن {configApp?.title}
							</div>
						</div>
						<div className="d-flex align-items-center" style={{marginRight: 'auto'}}>
							<Link to={{ pathname: "https://cafebazaar.ir/app/com.bebin.app" }} target="_blank" className="bazaar">
								<ImageGenerator src={bazaar}  style={{maxHeight: '32px'}}/>
							</Link>
							<Link to={{ pathname: "https://play.google.com/store/apps/details?id=com.bebin.app&pcampaignid=web_share" }} target="_blank" className="d-flex">
								<ImageGenerator src={googlePlay} />
							</Link>
						</div>
					</div>

					<div className="d-flex" style={{justifyContent: 'space-between', paddingTop: '18px'}}>
						<div className="links">
							<Link to={'/faq'}>
								سوالات متداول
							</Link>
							<Link to={'/terms'}>
								قوانین
							</Link>
							<Link to={'/dmca'}>
								DMCA
							</Link>
							<Link to={'/contact-us'}>
								تماس با ما
							</Link>
						</div>
						<div className="d-flex" style={{ maxHeight: '68px', gap: '10px' }}>
							<a href="https://satra.ir/" target="_blank" rel="nofollow" style={{ width: '59px' }}>
								<ImageGenerator src={satra} />
							</a>
							<a href="https://sapra.ir/" target="_blank" rel="nofollow" style={{ width: '59px' }}>
								<ImageGenerator src={sapraa} />
							</a>
						</div>
					</div>
				</div>
				<div className="about-us">
					<p style={{ marginBottom: '15px' }}>
					<strong>
							درباره ما
						</strong>
					</p>
					<p>
						تماشای فیلم و سریال های مورد علاقه شما هرگز به چنین آسانی نبوده است. ما با
						افتخار {configApp?.title} را به شما معرفی می کنیم که این امکان را برای شما فراهم می کند تا با
						کیفیت بالا و بدون محدودیت زمانی فیلم ها و سریال های مورد علاقه خود را تماشا کنید.از برنامه ما
						برای پخش فیلم ها و سریال های محبوب استفاده کنید و لذت ببرید. با دسترسی به یک کتابخانه بزرگ از
						فیلم ها و سریال های برتر، هرگز نباید به دنبال سرگرمی باشید. همچنین، ما به شما این امکان را می
						دهیم تا از اپلیکیشن خود رایگان استفاده کنید و فیلم و سریال مورد علاقه خودتون رو رایگان ببینین.
					</p>
				</div>
			</div>
		</footer>
	)
}
